import { CircleAlert } from 'lucide-react'

import {
  Timestamp,
  Tooltip,
  TooltipLabel,
} from '~/components/component-library'
import { SignerIcon } from '~/components/smart-accounts/SignerIcon'
import { OrgSigner } from '~/types'

export const PasskeyIconWithTooltip = ({
  signer,
  userPasskeys,
}: {
  signer: OrgSigner
  userPasskeys: OrgSigner[]
}) => {
  const {
    isArchived,
    lastVerifiedAt,
    providerIconLight,
    providerIconDark,
    id,
    name,
    createdAt,
  } = signer

  // defaulting to the name from userPasskey because it updates immediately after editing
  const userPasskey = userPasskeys.find((p) => p.id === id)

  return (
    <Tooltip
      content={
        <TooltipLabel
          title={userPasskey?.name ?? name ?? ''}
          detail={
            isArchived ? (
              <RemovedTooltipText />
            ) : (
              <LastUsedTooltipText lastVerifiedAt={lastVerifiedAt!} />
            )
          }
        />
      }
      triggerClassName="relative flex h-6 w-6 items-center justify-center rounded-full border-[2px] border-white bg-surface-strong transition-[margin] duration-150 dark:border-black"
    >
      <>
        <SignerIcon
          signer={{
            id,
            name: name ?? '',
            createdAt,
            providerIconDark,
            providerIconLight,
          }}
          size={14}
        />
        {isArchived && (
          <div className="absolute m-[0_auto] flex h-full w-full items-center justify-center rounded-full border-2 border-orange-500">
            <div className="absolute -bottom-1 -right-1 flex h-3 w-3 items-center justify-center rounded-full bg-orange-500 text-[10px] font-bold text-white">
              !
            </div>
          </div>
        )}
      </>
    </Tooltip>
  )
}

export const RemovedTooltipText = () => (
  <>
    <span className="flex items-center text-orange-500">
      <CircleAlert className="mr-1 h-3 w-3" />
      Removed by owner
    </span>
    <span className="text-secondary">
      We suggest removing this passkey from this account
    </span>
  </>
)

export const LastUsedTooltipText = ({
  lastVerifiedAt,
}: {
  lastVerifiedAt?: Date | string
}) => (
  <span className="text-secondary">
    {lastVerifiedAt ? (
      <>
        Last used{' '}
        <Timestamp
          timestamp={new Date(lastVerifiedAt).getTime()}
          type="relative"
          abbreviate
          showTooltip={false}
        />
      </>
    ) : (
      'Not yet used'
    )}
  </span>
)
